module.exports = __webpack_public_path__ + "assets/img/exe.f8096a1d.svg";